import { Link } from 'react-router-dom'

import Fb from '../Imgs/newIcons/facebook.png'
import Inst from '../Imgs/newIcons/instagram.png'
import Twt from '../Imgs/newIcons/twitter.png'
import Yt from '../Imgs/newIcons/youtube.png'

import pypLogoC from '../Imgs/newIcons/pypLogoC.png'

function Footer() {
  return (
    <div className="bg-Main px-4 py-20 !text-white">
      {/* Columnas de navegación */}
      <div className="mx-auto max-w-7xl">
        <div className="flex flex-wrap justify-between gap-8">
          {/* La compañía */}
          <div className="mb-4">
            <div className="mb-2 px-3 text-lg font-semibold !text-white">
              La compañía
            </div>
            <div className="mt-8 space-y-4">
              <Link
                to="/quienes-somos"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  ¿Quiénes somos?
                </div>
              </Link>
              <Link
                to="/lo-que-ofrecemos"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  Lo que ofrecemos
                </div>
              </Link>
              <Link
                to="/trabaja-con-nosotros"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  Trabaja con nosotros
                </div>
              </Link>
            </div>
          </div>

          {/* Soy restaurante */}
          <div className="mb-4">
            <div className="mb-2 px-3 text-lg font-semibold !text-white">
              Soy restaurante
            </div>
            <div className="mt-8 space-y-4">
              <a
                href="https://restaurantes.pideypasa.com"
                target="_blank"
                rel="noreferrer"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  Iniciar sesión como restaurante
                </div>
              </a>
              <a
                href="https://restaurantes.pideypasa.com/auth/singup"
                target="_blank"
                rel="noreferrer"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  Quiero registrar mi restaurante
                </div>
              </a>
              <Link
                to="/como-funciona"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  ¿Cómo funciona?
                </div>
              </Link>
            </div>
          </div>

          {/* Contacto */}
          <div className="mb-4">
            <div className="mb-2 px-3 text-lg font-semibold !text-white">
              Contacto
            </div>
            <div className="mt-8 space-y-4">
              <a
                href="https://pideypasa.atlassian.net/helpcenter/PYP/contact-us"
                target="_blank"
                rel="noreferrer"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  Necesito ayuda
                </div>
              </a>
            </div>
          </div>

          {/* Legales */}
          <div className="mb-4">
            <div className="mb-2 px-3 text-lg font-semibold !text-white">
              Legales
            </div>
            <div className="mt-8 space-y-4">
              <Link
                to="/politica-privacidad"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  Política de privacidad
                </div>
              </Link>
              <Link
                to="/terminos-condiciones"
                className="block text-left !text-white hover:!text-white"
              >
                <div className="!text-white whitespace-nowrap rounded-2xl px-3 py-1.5 text-sm hover:bg-white/10">
                  Términos y condiciones
                </div>
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Logo, redes sociales y copyright */}
      <div className="my-[30px] flex flex-col items-center">
        <div className="my-3 flex w-[400px] flex-col items-center px-[20px] text-center lg:text-start">
          <img src={pypLogoC} className="mr-[30px] w-[200px]" alt="PideYPasa" />
          <div className="my-[30px] flex w-full justify-center">
            <a
              href="https://www.facebook.com/profile.php?id=100088170187471"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={Fb}
                className="mr-[25px] h-[25px] w-[25px]"
                alt="Facebook"
              />
            </a>
            <a
              href="https://www.instagram.com/pideypasa/"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={Inst}
                className="mx-[25px] h-[25px] w-[25px]"
                alt="Instagram"
              />
            </a>
            <a
              href="https://twitter.com/pideypasa"
              target="_blank"
              rel="noreferrer"
            >
              <img src={Twt} className="mx-[25px] h-[25px] w-[25px]" alt="X" />
            </a>
            <a
              href="https://www.youtube.com/@PideYpasa/f"
              target="_blank"
              rel="noreferrer"
            >
              <img
                src={Yt}
                className="mx-[25px] h-[25px] w-[25px]"
                alt="YouTube"
              />
            </a>
          </div>
          <p className="w-[200px] text-center text-sm !text-white md:w-full">
            © 2026 Tecnicall Colombia S.A.S. Derechos reservados.
          </p>
        </div>
      </div>
    </div>
  )
}

export default Footer
